export const TYPE_ESTIMATE_THRESHOLD = 0.7

export let DataCollectionSelect = {
  dataCollectionId: '',
  dataCollectionName: '',
  categoryId: '',
  categoryName: '',
  description: '',
  subsets: [],
  use: false,
  isIndeterminate: false,
  xType: [],
  indexColumns: [],
  filterTypes: [],
  sampleVal: ''
}

export let Subset = {
  subsetName: '',
  use: false,
  subsetColumns: []
}

export let TypeDefine = {
  id: '',
  name: '',
  dataCollections: []
}

export let CollectResultPreview = {
  columns: [],
  data: [],
  count: Number
}

export let CollectResult = {
  dataCollectionId: '',
  categoryId: '',
  result: CollectResultPreview
}

export let Corporation = {
  corpCode: '',
  corpName: '',
  corpType: '',
  pref: '',
  city: '',
  street: '',
  location: '',
  postalCode: '',
  updatedAt: ''
}
export let CorporationDispColumnInfo = {
  value: '',
  label: ''
}

export const DATA_COLLECTION_DEFINES = [
  {
    dataCollectionId: '0001',
    dataCollectionName: '政府統計（サマリ）',
    categoryId: null,
    categoryName: null,
    indexColumns: ['都道府県'],
    description: `政府が公表している各種統計データを都道府県単位で集計したデータです。
                  人口や世帯数といった基本的な情報に加え、学校数や図書館数などの情報も含まれています。`,
    filterTypes: ['prefs']
  },
  {
    dataCollectionId: '0004',
    dataCollectionName: '政府統計（詳細）',
    categoryId: null,
    categoryName: null,
    indexColumns: ['地域コード', '地域', '都道府県', '名称', 'よみがな', '郵便番号', '住所'],
    description: `政府が公表している各種統計データを市区町村単位で集計したデータです。
                  人口や世帯数といった基本的な情報に加え、行政・財政に関する情報や事業所数といった経済情報などの幅広い情報が含まれています。`,
    filterTypes: ['prefs', 'address']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_market',
    categoryName: 'マーケット関連',
    indexColumns: ['年月'],
    description: `日本銀行が公表しているマーケットに関連する情報の時系列統計データです。
                  為替やコールレートに関する情報が含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_bank_bs',
    categoryName: '金融機関バランスシート',
    indexColumns: ['年月'],
    description: `日本銀行が公表している金融機関バランスシートについての時系列統計データです。
                  貸出金と実質預金の推移が含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_interest',
    categoryName: '金利',
    indexColumns: ['年月'],
    description: `日本銀行が公表している各種金利についての時系列統計データです。
                  基準割引率や、短期・長期の金利の情報などが含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_bop_international',
    categoryName: '国際収支',
    indexColumns: ['年月'],
    description: `日本銀行が公表している国際収支についての時系列統計データです。
                  経常収支と金融収支の情報が含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_family_financial_asset',
    categoryName: '家計金融資産',
    indexColumns: ['年月'],
    description: `日本銀行が公表している家計金融資産についての時系列統計データです`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_loan',
    categoryName: '貸出',
    indexColumns: ['年月'],
    description: `日本銀行が公表している各種の貸し出しについての時系列統計データです。
                  銀行・法人・個人の貸出に関する情報が含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_tankan_fiscal_budget',
    categoryName: '短観__年度計画',
    indexColumns: ['年月'],
    description: `日本銀行が公表している短観（全国企業短期経済観測調査）についての時系列統計データです。
                  調査対象企業の四半期ごとの経常利益や設備投資額などのデータが含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_tankan_di',
    categoryName: '短観__DI',
    indexColumns: ['年月'],
    description: `日本銀行が公表している短観（全国企業短期経済観測調査）についての時系列統計データです。
                  企業の業況感や設備、雇用人員の過不足などの各種判断を指数化したデータが含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_price',
    categoryName: '物価',
    indexColumns: ['年月'],
    description: `日本銀行が公表している物価についての時系列統計データです。
                  SPI（サービス価格指数）やCGPI（国内企業物価指数）に関するデータが含まrています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0003',
    dataCollectionName: '日銀統計',
    categoryId: 'conv_boj_money',
    categoryName: '預金・マネー',
    indexColumns: ['年月'],
    description: `日本銀行が公表している通貨供給や預金についての時系列統計データです。
                  紙幣や貨幣の流通状況や預金額の推移などのデータが含まれています。`,
    filterTypes: ['yearMonth']
  },
  {
    dataCollectionId: '0005',
    dataCollectionName: '地価公示',
    categoryId: null,
    categoryName: null,
    indexColumns: ['標準地番号'],
    description: `適正な地価形成のため、国土交通省が公表しているデータです。
                  地価の他に、建物の構造や土地の用途や最寄り駅までの距離といった地価の算出に使用されるデータが利用可能です。`,
    sampleVal: `項目例）
                価格[円/㎡]
                構造
                利用現況
                最寄り駅までの距離[m]
                など 23項目`,
    filterTypes: ['pref', 'address']
  },
  {
    dataCollectionId: '0006',
    dataCollectionName: '不動産取引価格',
    categoryId: null,
    categoryName: null,
    indexColumns: ['都道府県', '所在地'],
    description: `実際の取引価格情報を国土交通省が蓄積、公表しているデータです。
                  取引価格だけではなく、最寄り駅までの距離や物件前面の道路情報などのデータが含まれています。`,
    filterTypes: ['pref', 'address']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_tao_trans',
    categoryName: '交通事故発生状況',
    indexColumns: ['年'],
    description: `警察庁が公表している年毎の交通事故発生件数・死者数・負傷者数のデータです。`,
    filterTypes: ['year']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_tao_pref',
    categoryName: '都道府県別の交通事故発生状況',
    indexColumns: ['都道府県'],
    description: `警察庁が公表している、犯罪種別ごとの認知件数・検挙件数・検挙人員を都道府県毎に集計したデータです。`,
    sampleVal: ` 項目例）
                  ・凶悪犯 認知件数[件]
                  ・凶悪犯 検挙件数[件]
                  ・凶悪犯 検挙人員[人]
                  ・凶悪犯 認知件数[件]
                  など 22項目`,
    filterTypes: ['prefs']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_nacd_pref_trans',
    categoryName: '自動車運転代行業者数',
    indexColumns: ['都道府県'],
    description: `警察庁が公表している、各都道府県ごとの自動車運転代行業者数です。`,
    filterTypes: ['prefs']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_nhdl_age_gender',
    categoryName: '運転免許保有者数(2016)',
    indexColumns: ['年齢'],
    description: `警察庁が公表している、男女・年代別の運転免許保持者数のデータです。`,
    filterTypes: []
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_pco_pref',
    categoryName: '都道府県別刑法犯(2016)',
    indexColumns: ['エリア', '都道府県'],
    description: `警察庁が公表している、交通事故の発生数・死者数・負傷者数とその増減を都道府県毎に集計したデータです。`,
    sampleVal: ` 項目例）
                ・発生件数[件]
                ・発生件数 増減数[件]
                ・発生件数 増減[％]
                ・死者数[件]
                 など 9項目`,
    filterTypes: ['prefs']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_nobc_ap_trans',
    categoryName: '少年相談件数(2016)',
    indexColumns: ['年'],
    description: `警察庁が公表している、少年・少女の相談件数やその内訳、犯罪数を集計したデータです。`,
    filterTypes: ['year']
  },
  {
    dataCollectionId: '0007',
    dataCollectionName: '警察白書',
    categoryId: 'conv_pwp_as_nfvj_trans',
    categoryName: '来日外国人の国籍別検挙件数',
    indexColumns: ['年'],
    description: `警察庁が公表している、年別・国別での来日外国人の検挙件数を集計したデータです。`,
    filterTypes: ['year']
  },
  {
    dataCollectionId: '0002',
    dataCollectionName: '企業情報収集',
    categoryId: null,
    categoryName: null,
    indexColumns: ['法人番号'],
    description: `日本国内の法人の所在地や電話番号などの情報を取得出来ます。`,
    filterTypes: ['corporateName']
  }
]

export const TYPE_DEFINES = [
  {
    id: 'prefecture',
    name: '都道府県',
    dataCollections: [
      { dataCollectionId: '0001', categoryId: null },
      // {dataCollectionId: "0004", categoryId: null},
      // {dataCollectionId: "0005", categoryId: null},
      { dataCollectionId: '0007', categoryId: 'conv_pwp_tao_pref' },
      { dataCollectionId: '0007', categoryId: 'conv_pwp_nacd_pref_trans' },
      { dataCollectionId: '0007', categoryId: 'conv_pwp_pco_pref' }
    ]
  },
  {
    id: 'standardNumber',
    name: '標準値番号',
    dataCollections: [
      // {dataCollectionId: "0001", categoryId: null},
      // {dataCollectionId: "0004", categoryId: null},
      { dataCollectionId: '0005', categoryId: null }
      // {dataCollectionId: "0007", categoryId: "conv_pwp_tao_pref"},
      // {dataCollectionId: "0007", categoryId: "conv_pwp_nacd_pref_trans"},
      // {dataCollectionId: "0007", categoryId: "conv_pwp_pco_pref"},
    ]
  },
  {
    id: 'regionCode',
    name: '地域コード',
    dataCollections: [
      // {dataCollectionId: "0001", categoryId: null},
      { dataCollectionId: '0004', categoryId: null }
      // {dataCollectionId: "0005", categoryId: null},
      // {dataCollectionId: "0007", categoryId: "conv_pwp_tao_pref"},
      // {dataCollectionId: "0007", categoryId: "conv_pwp_nacd_pref_trans"},
      // {dataCollectionId: "0007", categoryId: "conv_pwp_pco_pref"},
    ]
  }
]



// WEBPACK FOOTER //
// ./src/defines/data-collection.js